<template>
  <v-container class="pa-0">
    <v-row v-if="category" no-gutters>
      <div class="font-weight-heavy">
        {{ category.title }}
        <span style="transition: color, 0.2s ease"
              :class="catergoryAlert.class"
              v-html="catergoryAlert.text"
        ></span>
      </div>
    </v-row>
    <profile-selector :cards="cards" @select="cardSelection($event)"></profile-selector>
  </v-container>
</template>

<script>
import ProfileSelector from "@/views/Tools/SecPeak/Components/ProfileSelector";

export default {
  name: "PitstopPeopleB",
  components: {
    ProfileSelector
  },
  props: {
    category: {
      type: Object,
    },
    categoryIndex: {
      type: String
    }
  },
  data: () => ({
    selection: [],
    cards: []
  }),
  computed: {
    catergoryAlert() {
      let alert = {
        state: false,
        type: 'error',
        text: '',
      }
      if (this.selection.length > this.category.maxItems) {
        alert = {
          state: true,
          class: 'error--text',
          text: `You have selected ${(this.selection.length - this.category.maxItems)} too many items.`,
        }
      } else if (this.selection.length >= 1 && (this.selection.length < (this.category.maxItems - 1))) {
        alert = {
          state: true,
          class: 'warning--text',
          text: `Please select ${this.category.maxItems - this.selection.length} more items.`,
        }
      } else if (this.selection.length === (this.category.maxItems - 1)) {
        alert = {
          state: true,
          class: 'warning--text',
          text: `Please select ${this.category.maxItems - this.selection.length} more item.`,
        }
      } else if (this.selection.length === this.category.maxItems) {
        alert = {
          state: true,
          class: 'success--text',
          text: `${this.category.maxItems} Items successfully selected.`,
        }
      } else if (this.selection.length === 0) {
        alert = {
          state: true,
          class: 'text',
          text: `Please select ${this.category.maxItems} items.`,
        }
      } else {
        alert = {
          state: false,
        }
      }

      return alert;
    },
  },
  methods: {
    initCards() {
      return this.cards = this.category.cards.map((card) => {
        return {
          ...card,
          selected: false
        }
      });
    },
    cardSelection(card) {
      if (!card.selected) {
        this.$set(card, 'selected', true)
        this.selection.push(card)
      } else {
        this.$set(card, 'selected', false)
        this.selection = this.selection.filter(selectedCards => selectedCards.id !== card.id)
      }
    },
    reset() {
      this.selection = [];
      this.cards.forEach((card) => this.$set(card, 'selected', false));
    }
  },
  mounted() {
    this.initCards()
  }
}
</script>

<style scoped>

</style>